module.exports = __webpack_public_path__ + "img/tool_btn_active_model.60484e90.svg";